import * as THREE from 'three';

export class Marker {
  readonly object: THREE.Group;
  private beamMat: THREE.MeshBasicMaterial;
  private ringMat: THREE.MeshBasicMaterial;
  private ring: THREE.Mesh;
  private pulseTime = 0;

  constructor() {
    this.object = new THREE.Group();

    const beamGeom = new THREE.CylinderGeometry(0.3, 0.3, 24, 16, 1, true);
    this.beamMat = new THREE.MeshBasicMaterial({
      color: 0xffcc33,
      transparent: true,
      opacity: 0.35,
      side: THREE.DoubleSide,
      depthTest: false,
      blending: THREE.AdditiveBlending,
    });
    const beam = new THREE.Mesh(beamGeom, this.beamMat);
    beam.position.y = 12;
    beam.renderOrder = 9999;
    this.object.add(beam);

    const ringGeom = new THREE.RingGeometry(1.2, 1.8, 32);
    this.ringMat = new THREE.MeshBasicMaterial({
      color: 0xffcc33,
      transparent: true,
      opacity: 0.9,
      side: THREE.DoubleSide,
      depthTest: false,
    });
    this.ring = new THREE.Mesh(ringGeom, this.ringMat);
    this.ring.rotation.x = -Math.PI / 2;
    this.ring.position.y = 0.08;
    this.ring.renderOrder = 9999;
    this.object.add(this.ring);

    this.object.visible = false;
  }

  setPosition(x: number, z: number) {
    this.object.position.set(x, 0, z);
  }

  setColor(hex: number) {
    this.beamMat.color.setHex(hex);
    this.ringMat.color.setHex(hex);
  }

  setVisible(v: boolean) {
    this.object.visible = v;
  }

  update(delta: number) {
    if (!this.object.visible) return;
    this.pulseTime += delta;
    const pulse = 1 + 0.15 * Math.sin(this.pulseTime * 4);
    this.ring.scale.set(pulse, pulse, pulse);
    this.ring.rotation.z += delta * 0.5;
  }
}
